<template>
    <div class="auth-form auth-loading">
        <div v-if="!hasError" class="auth-loading__content">
            <div class="auth-loading__spinner">
                <div class="auth-loading__ring" />
            </div>
            <p class="auth-loading__message">{{ message }}</p>
        </div>
        <div v-else class="auth-loading__content">
            <div class="auth-loading__error-icon">
                <i class="pi pi-exclamation-circle" />
            </div>
            <p class="auth-loading__error-message">{{ errorMessage }}</p>
            <Button
                v-if="showRetry"
                label="Try Again"
                severity="primary"
                @click="$emit('retry')"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import Button from 'primevue/button';

withDefaults(defineProps<{
    message?: string;
    hasError?: boolean;
    errorMessage?: string;
    showRetry?: boolean;
}>(), {
    message: 'Redirecting…',
    hasError: false,
    errorMessage: 'Something went wrong. Please try again.',
    showRetry: true,
});

defineEmits<{
    retry: [];
}>();
</script>

<style lang="scss" scoped>
.auth-loading {
    align-items: center !important;
    justify-content: center !important;
    min-height: 200px;

    &__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 28px;
    }

    &__spinner {
        width: 52px;
        height: 52px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__ring {
        width: 52px;
        height: 52px;
        border-radius: 50%;
        border: 3px solid rgba($main-orange, 0.15);
        border-top-color: $main-orange;
        animation: auth-spin 0.9s cubic-bezier(0.4, 0.15, 0.6, 0.85) infinite;
    }

    &__message {
        font-size: 15px;
        font-weight: 400;
        color: $auth-layout-font-color;
        letter-spacing: 0.02em;
        margin: 0;
    }

    &__error-icon {
        .pi {
            font-size: 40px;
            color: $error-red;
        }
    }

    &__error-message {
        font-size: 15px;
        font-weight: 400;
        color: $auth-layout-font-color;
        text-align: center;
        margin: 0;
        line-height: 1.5;
    }

    :deep(.p-button) {
        padding: 12px 40px;
        font-weight: 600;
        font-size: 15px;
        color: $white-color;
        background: $main-orange;
        border-color: $main-orange;
        border-radius: 8px;

        &:hover {
            background: $main-orange-hover;
            border-color: $main-orange-hover;
        }
    }
}

@keyframes auth-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
